export default __webpack_public_path__ + "static/media/Picture7.c70d4b23.png";